"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _tile = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/tile.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _tile.default);

var TileFooter = function TileFooter(props) {
  var children = props.children,
      className = props.className,
      cssNamespace = props.cssNamespace,
      rest = (0, _objectWithoutProperties2.default)(props, ["children", "className", "cssNamespace"]);
  var tileFooterClasses = classnames("".concat(cssNamespace, "-tile__footer"), className);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, rest, {
    className: tileFooterClasses
  }), children);
};

TileFooter.displayName = 'Tile.Footer';
process.env.NODE_ENV !== "production" ? TileFooter.propTypes = {
  /** Node(s) to render inside the header element */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string
} : void 0;

var _default = (0, _withStyles.default)(TileFooter);

exports.default = _default;